import { render, staticRenderFns } from "./_base-favourites.vue?vue&type=template&id=09876322&scoped=true"
import script from "./_base-favourites.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-favourites.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-favourites.vue?vue&type=style&index=0&id=09876322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09876322",
  null
  
)

export default component.exports